enum ABTestVariationEnum {
	A = 'A',
	B = 'B'
}

export default ABTestVariationEnum;
